<template>
  <div class="page-container">
    <el-card>
      <app-filter
        :filter-list="table_filter"
        default-label-width="90px"
        @search="onSearch"
      />
    </el-card>
    <el-card class="mt-20">
      <el-button type="primary" size="mini" @click="onAdd">新增配置</el-button>
      <i class="el-icon-warning tips-icon" />
      <span class="tips">预警功能将监控指定渠道类型 - 渠道子类型 - 子游戏下的每个渠道，在一个自然日内的消耗及转化指标数据是否存在异常，并及时发出预警通知；预警监控频率为每30分钟一次</span>
    </el-card>
    <el-card class="mt-20">
      <app-table
        ref="table"
        :table-key="table_key"
        :table-props="{ 'max-height': '550px' }"
        :tablep="table_params"
        :page-size="10"
        :get-data="getMonitorRuleList"
      />
    </el-card>
    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      width="800px"
    >
      <app-form
        v-if="dialog_config.is_show"
        :form-data="dialog_config.form_config"
        default-label-width="90px"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.is_show = false"
      >
        <template #custom="{ form_key, form_item }">
          <div v-if="form_key === 'rules'">
            <div v-for="(item, i) in form_item.value" :key="i" class="font-bold mb-10">
              <span class="color-red">消耗</span>
              <span class="ml-5 mr-5">大于等于</span>
              <el-input-number v-model="item.cost" controls-position="right" :min="0" :precision="0" />
              <span class="ml-5 mr-5">元，且</span>
              <span class="color-green">{{ condition_type_map[item.condition_type] }}</span>
              <span class="ml-5 mr-5">小于</span>
              <el-input-number v-model="item.condition_value" controls-position="right" :min="0" :precision="0" />
              <span class="ml-5">个</span>
            </div>
            <div class="color-red">
              <div>注意：</div>
              <div>触发条件为消耗-注册数/创角数时，消耗判定规则为渠道当天(一个自然日内)产生的消耗，触发告警时1次/天</div>
              <div>触发条件为消耗-付费人数时，消耗判定规则为渠道近半年产生的总消耗，且条件触发时仅通知1次</div>
              <div>满足以上任意一行条件时触发告警</div>
            </div>
          </div>
        </template>
      </app-form>
    </el-dialog>
  </div>
</template>

<script>
// 获取游戏列表接口
import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();
import { getChannelTypeSelectorListApi } from '@/api/channel-type';
import {
  getMonitorRuleListApi,
  addMonitorRuleApi,
  editMonitorRuleApi,
  switchMonitorRuleStatusApi,
  delMonitorRuleApi,
} from '@/api/monitor-rule';
import { formDataAssign } from '@/tools/form';
import { clone } from '@/utils';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'app-form': () => import('@/components/app-form'),
  },
  data() {
    return {
      table_key: require('./model/table-key.js')(this),
      table_filter: require('./model/table-filter.js')(this),
      table_params: {
        page: 1,
        limit: 10,
      },
      /** 弹窗配置 */
      dialog_config: {
        is_show: false,
        title: '新增',
        id: null,
        form_config: {},
        confirm: () => {},
      },
      condition_type_map: {
        1: '注册数',
        2: '创角数',
        3: '付费人数',
      },
      channel_type1_list_options: [],
      game_options: [],
    };
  },
  async created() {
    this.channel_type1_list_options = await this.getChannelType1List();
    this.table_filter.channel_type1_list.options = this.channel_type1_list_options;
    this.game_options = await this.getGameList();
    this.table_filter.game_id_list.props.options = this.game_options;
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 搜索条件
     */
    onSearch(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.seekTable();
    },
    /** 新增 */
    onAdd() {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '新增',
        form_config: require('./model/form-config.js')(),
        confirm: (params) => {
          const { rules } = params;
          // 未填写触发条件
          if (!rules?.length) {
            this.$message.warning('请至少完整填写一条触发条件');
            return;
          }
          // 填写了消耗但未填写对应值
          const incomplete_rule_condition = rules.find(({ cost, condition_value }) => cost && !condition_value);
          if (incomplete_rule_condition) {
            this.$message.warning(`请输入${this.condition_type_map[incomplete_rule_condition.condition_type]}`);
            return;
          }
          // 填写了对应值但未填写消耗
          const incomplete_rule_cost = rules.find(({ cost, condition_value }) => !cost && condition_value);
          if (incomplete_rule_cost) {
            this.$message.warning(`请输入消耗`);
            return;
          }
          // 过滤不合法值
          Object.assign(params, { rules: rules.filter(({ cost, condition_value }) => cost && condition_value) });
          addMonitorRuleApi(params).then(({ message }) => {
            this.$message.success(message || '新增成功');
            this.dialog_config.is_show = false;
            this.$refs.table.seekTable();
          });
        },
      });
      const { channel_type1_list, channel_type2_list, game_id_list } = this.dialog_config.form_config;
      channel_type1_list.options = this.channel_type1_list_options;
      channel_type1_list.on = {
        change: async(value) => {
          channel_type2_list.options = await this.getChannelType2List(value);
        },
      };
      game_id_list.props.options = this.game_options;
      game_id_list.on = {
        getcheckedValue: (game_ids) => {
          game_id_list.value = game_ids?.length ? game_ids : null;
        },
      };
    },
    /**
     * 编辑
     * @param {Object} row 当前行数据
     */
    onEdit(row) {
      const data = clone(row);
      const { id, rule_list, ...rest } = data;
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '编辑',
        id,
        form_config: require('./model/form-config.js')(),
        confirm: (params) => {
          const { rules } = params;
          // 未填写触发条件
          if (!rules?.length) {
            this.$message.warning('请至少完整填写一条触发条件');
            return;
          }
          // 填写了消耗但未填写对应值
          const incomplete_rule_condition = rules.find(({ cost, condition_value }) => cost && !condition_value);
          if (incomplete_rule_condition) {
            this.$message.warning(`请输入${this.condition_type_map[incomplete_rule_condition.condition_type]}`);
            return;
          }
          // 填写了对应值但未填写消耗
          const incomplete_rule_cost = rules.find(({ cost, condition_value }) => !cost && condition_value);
          if (incomplete_rule_cost) {
            this.$message.warning(`请输入消耗`);
            return;
          }
          // 过滤不合法值
          Object.assign(params, { rules: rules.filter(({ cost, condition_value }) => cost && condition_value) });
          editMonitorRuleApi(params, id).then(({ message }) => {
            this.$message.success(message || '编辑成功');
            this.dialog_config.is_show = false;
            this.$refs.table.seekTable();
          });
        },
      });
      // 初始化规则
      const rules = this.dialog_config.form_config.rules.value.map(rule => {
        const current_rule = rule_list.find(({ condition_type }) => condition_type === rule.condition_type);
        return current_rule || { cost: undefined, condition_type: rule.condition_type, condition_value: undefined };
      });
      formDataAssign(this.dialog_config.form_config, { rules, ...rest });
      const { channel_type1_list, channel_type2_list, game_id_list } = this.dialog_config.form_config;
      channel_type1_list.options = this.channel_type1_list_options;
      channel_type1_list.on = {
        change: async(value) => {
          channel_type2_list.options = await this.getChannelType2List(value);
        },
      };
      game_id_list.props.options = this.game_options;
      game_id_list.on = {
        getcheckedValue: (game_ids) => {
          game_id_list.value = game_ids?.length ? game_ids : null;
        },
      };
      channel_type1_list.on.change(channel_type1_list.value);
    },
    /**
     * 切换状态
     * @param {Object} row 当前行数据
     */
    onSwitch(row) {
      const { id, rule_name, channel_type1_list, channel_type2_list, game_id_list, status, rule_list: rules } = row;
      const h = this.$createElement;
      const message_ele = h('div', { class: 'flex-col align-center' }, [
        h('div', { class: 'mb-10' }, rule_name),
        h('div', null, [
          h('span', null, '是否'),
          h('span', { class: 'color-red ml-5 mr-5' }, status === 1 ? '停用' : '启用'),
          h('span', null, '当前已选中的配置'),
        ]),
      ]);
      this.$msgbox({
        title: '提示',
        message: message_ele,
        showCancelButton: true,
      }).then(() => {
        const params = {
          rule_name,
          channel_type1_list,
          channel_type2_list,
          game_id_list,
          status: status === 1 ? 2 : 1,
          rules,
        };
        switchMonitorRuleStatusApi(params, id).then(({ message }) => {
          this.$message.success(message || '操作成功');
          this.$refs.table.seekTable();
        });
      });
    },
    /**
     * 删除
     * @param {Object} row 当前行数据
     */
    onDel(row) {
      const { id, rule_name } = row;
      const h = this.$createElement;
      const message_ele = h('div', { class: 'flex-col align-center' }, [
        h('div', { class: 'mb-10' }, rule_name),
        h('div', null, [
          h('span', null, '是否'),
          h('span', { class: 'color-red ml-5 mr-5' }, '删除'),
          h('span', null, '当前已选中的配置'),
        ]),
      ]);
      this.$msgbox({
        title: '提示',
        message: message_ele,
        showCancelButton: true,
      }).then(() => {
        delMonitorRuleApi(id).then(({ message }) => {
          this.$message.success(message || '删除成功');
          this.$refs.table.seekTable();
        });
      });
    },
    /**
     * 获取渠道类型
     * @returns {Promise<Object[]>}
     */
    getChannelType1List() {
      return new Promise((resolve, reject) => {
        getChannelTypeSelectorListApi().then(({ list }) => {
          const result = (list || []).map(({ id, name }) => ({ label: name, value: id }));
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取渠道子类型
     * @param {Object[]} channel_type1_list 渠道类型
     */
    getChannelType2List(channel_type1_list) {
      return new Promise((resolve, reject) => {
        getChannelTypeSelectorListApi(({ channel_type1_list })).then(({ list }) => {
          const result = (list || []).map(({ id, name }) => ({ label: name, value: id }));
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取游戏列表
     */
    getGameList() {
      return new Promise((resolve, reject) => {
        advertisingResource.getGameListApi(({ refresh: 1 })).then(({ list = [] }) => {
          const result = list.map(res => Object.assign(res, { disabled: true }));
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取预警配置列表
     * @param {Object} params 请求参数
     * @returns {Promise<Object>}
     */
    getMonitorRuleList(params) {
      return new Promise((resolve, reject) => {
        getMonitorRuleListApi(params).then(resolve).catch(reject);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tips-icon {
  margin-left: 20px;
  font-size: 16px;
  color: #F56C6C;
}
.tips {
  margin-left: 5px;
  font-size: 14px;
  color: #F56C6C;
}
.color-red {
  color: #F56C6C;
}
.color-green {
  color: #67C23A;
}
</style>
